import React from "react";
import { Link } from "react-router-dom";
import { useLang, pick } from "../i18n/LanguageContext";
import { t } from "../i18n/translations";
// Hero käyttää reunoista rajattua versiota, jotta merkki alkaa H:sta heti
// vasemmasta reunasta ja päättyy valkoiseen laatikkoon oikeassa reunassa.
import filmLogoWhite from "../assets/logos/Hetki-Company-Film-logo_white_trimmed.png";

const Film = () => {
  const { lang } = useLang();
  const tr = pick(lang);

  return (
    <article className="page page--film">
      {/* Koko ruudun hero: metsäkuvausten kuva + Hetki Film Company -logo
          kuvan päällä. Korvaa erillisen tumman logo-lockupin. */}
      <section className="film__hero">
        <img
          className="film__hero-photo"
          src="/images/hetki-film-kuvaukset-2.jpg"
          alt={tr(t.film.heroAlt)}
        />
        <img
          className="film__hero-logo"
          src={filmLogoWhite}
          alt="Hetki Film Company"
        />
      </section>

      <div className="page__inner">
        <header className="page__header film__header">
          <span className="film__eyebrow">{tr(t.film.eyebrow)}</span>
          <h1 className="page__title">{tr(t.film.title)}</h1>
          <p className="page__intro">{tr(t.film.intro1)}</p>
          <p className="page__intro">{tr(t.film.intro2)}</p>
        </header>

        <section className="page__section film__photo-wide">
          <img
            src="/images/hetki-film-kuvaukset-1.jpg"
            alt={tr(t.film.photoAlt)}
            loading="lazy"
          />
        </section>

        <section className="page__section page__cta">
          <h2 className="page__subtitle">{tr(t.film.ctaTitle)}</h2>
          <p className="page__intro">{tr(t.film.ctaBody)}</p>
          <div className="page__cta-links">
            <Link to="/yhteys" className="teaser__link">
              {tr(t.film.ctaLink)}
            </Link>
          </div>
        </section>
      </div>
    </article>
  );
};

export default Film;
